import { HttpErrorResponse, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { tap } from 'rxjs/operators';
import { GoogleAnalyticsService, PreInitSettingsService } from 'src/app/core/core';
import { GTMApiStatus, GTMEvents } from 'src/app/model/google-tag-manager/api-status';
@Injectable()
export class ServerErrorInterceptor implements HttpInterceptor {

  constructor(
    public googleAnalyticsService: GoogleAnalyticsService,
    private preInitSettingsService: PreInitSettingsService,
  ) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler) {
    return next.handle(request).pipe(
      tap({
        error: err => {
          if (err instanceof HttpErrorResponse) {
            // if (request.url.includes(`${this.billingPath}paymentprofile`)) {
            //   this.googleAnalyticsService.emitGTMEvent({
            //     event: GTMEvents.UpdatePayment,
            //     event_status: GTMApiStatus.Failed
            //   });
            // }
            // else if (request.url.includes(`${this.billingPath}payment`)) {
            //   this.googleAnalyticsService.emitGTMEvent({
            //     event: GTMEvents.MakePayment,
            //     event_status: GTMApiStatus.Failed
            //   });
            // }
          }
        }
      })
    );
  }
}
